import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import paymentsImage from '../../../assets/images/payments.png';
import styles from '../WhySellAtCatawiki.module.scss';

export const PaymentBlock = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.keyPointsBlock}>
      <Image
        placeholder="blur"
        src={paymentsImage}
        width={305}
        height={240}
        unoptimized
        alt="payment_illustration"
      />
      <h3 className="u-typography-h3 u-m-t-xxl-4">
        {t('seller_register.why.payments_title')}
      </h3>
      <h5 className="u-typography-h5 u-m-t-m u-color-secondary">
        {t('seller_register.why.payments_subtitle')}
      </h5>
    </div>
  );
};
